import type { IntlShape } from 'react-intl';
import { ArtistPortalEarningsGroup, ArtistPortalEarningsRow } from 'fym-shared/src/smartlinks/artistPortals';
import { countryName } from './streamingFormat';

/**
 * True when at least one row gives units as a number (a 0 counts). A group where no source gives
 * units (Ditto: null, an old server: no key) shows no Units column, not a column of dashes.
 */
export function rowsHaveUnits(rows: readonly ArtistPortalEarningsRow[]): boolean {
  return rows.some((row) => typeof row.quantity === 'number');
}

/** The text of a row label: a country name from the ISO code, else the label as it is. */
export function earningsRowLabel(intl: IntlShape, groupBy: ArtistPortalEarningsGroup, label: string): string {
  return groupBy === ArtistPortalEarningsGroup.country ? countryName(intl, label) : label;
}
